document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-carousel').forEach(section => {

    const slides = section.querySelectorAll('.hero-slide');
    const prev = section.querySelector('.hero-arrow.prev');
    const next = section.querySelector('.hero-arrow.next');

    if (slides.length <= 1) return;

    let index = 0;
    let timer;

    const autoplay = section.dataset.autoplay === 'true';
    const interval = parseInt(section.dataset.interval, 10) || 4000;

    function showSlide(i) {
      slides.forEach(slide => slide.classList.remove('active'));
      slides[i].classList.add('active');
      index = i;
    }

    function nextSlide() {
      showSlide((index + 1) % slides.length);
    }

    function prevSlide() {
      showSlide((index - 1 + slides.length) % slides.length);
    }

    next.addEventListener('click', nextSlide);
    prev.addEventListener('click', prevSlide);

    function startAutoplay() {
      if (!autoplay) return;
      timer = setInterval(nextSlide, interval);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    showSlide(0);
    startAutoplay();
  });
});
